import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  GeckoModal,
  GECKO_CONSTS,
  GeckoModalService,
  GeckoToastService,
  GeckoFields,
} from 'ui';
import ReplyBox from '../../conversations/components/ReplyBox';
import {
  convertToRaw,
  EditorState,
  ContentState,
  convertFromRaw,
} from 'draft-js';
import { buildContactGroup, buildAgentGroup } from 'services/template-tags';
import GeckoPermissions from 'services/gecko-permissions';

class EditModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      values: {},
    };
    this.updateCallbacks = {
      editorState: (editorState) => {
        const newState = { ...this.state };
        newState.values.editorState = editorState;
        return this.setState(newState);
      },
    };
  }
  UNSAFE_componentWillMount() {
    if (this.props.reply) {
      let values;
      if (!this.props.reply.editor_object && this.props.reply.contents) {
        // for older replies
        const newContent = ContentState.createFromText(
          this.props.reply.contents
        );
        const newEditorState = EditorState.createWithContent(newContent);
        const editor_obj = convertToRaw(newEditorState.getCurrentContent());
        values = Object.assign(this.props.reply, {
          editorState: newEditorState,
          editor_object: editor_obj,
        });
      } else {
        values = Object.assign(this.props.reply, {
          editorState: EditorState.createWithContent(
            convertFromRaw(this.props.reply.editor_object)
          ),
        });
      }
      this.setState({ values: values });
    }
  }

  templateContext() {
    const context = [
      buildContactGroup(),
      buildAgentGroup(this.props.loggedInUser),
    ];
    return context;
  }

  fields() {
    return [
      {
        label: 'Name',
        key: 'name',
        width: '100%',
        required: true,
      },
      {
        label: 'Assign saved reply to:',
        key: 'assigned_team_ids',
        type: GECKO_CONSTS.FIELD_TYPE_SELECT_MULTI,
        options: this.getUserTeams(),
        placeholder: 'All Agents and Teams',
        description:
          'By default, saved replies will be assigned to all agents and teams.',
        width: '100',
      },
      {
        label: 'Contents',
        key: 'editorState',
        required: true,
        width: '100',
        type: GECKO_CONSTS.FIELD_TYPE_CUSTOM,
        autoResize: true,
        component: (
          <ReplyBox
            editorState={this.state.values.editorState}
            toolbarClassName={'saved-replies'}
            noDragUpload={true}
            updateCallbacks={this.updateCallbacks}
            compileTemplateTags={false}
            templateContext={this.templateContext()}
            meta={{
              saved_replies: { show: true },
              attachments: { show: true },
              mail_merge: { show: true },
            }}
          />
        ),
      },
    ];
  }
  footerBtns = [
    {
      preset: 'save',
      handler: () => {
        if (!this.state.values.editorState) {
          return new GeckoToastService().error(
            'The contents field is required'
          );
        }
        const hasContents = this.state.values.editorState
          .getCurrentContent()
          .hasText();
        const replyContents = {
          editor_object: convertToRaw(
            this.state.values.editorState.getCurrentContent()
          ),
          contents: this.state.values.editorState
            .getCurrentContent()
            .getPlainText(),
        };
        this.setState(
          { values: Object.assign(this.state.values, replyContents) },
          () => {
            if (!this.state.values) {
              return new GeckoToastService().error(
                'The name and contents fields are required'
              );
            }
            if (!this.state.values.name) {
              return new GeckoToastService().error(
                'The name field is required'
              );
            }
            if (!hasContents) {
              return new GeckoToastService().error(
                'The contents field is required'
              );
            }
            const name = this.state.values.name;
            const editor_object = this.state.values.editor_object;
            const contents = this.state.values.contents;
            const assigned_team_ids = this.state.values.assigned_team_ids || [];
            new GeckoModalService().close({
              name,
              editor_object,
              contents,
              assigned_team_ids,
            });
          }
        );
      },
    },
  ];
  changeHandler(key, val) {
    const newValues = Object.assign({}, this.state.values, { [key]: val });
    this.setState({ values: newValues });
  }
  render() {
    const fields = this.fields();
    return (
      <GeckoModal
        name={this.props.reply ? 'Edit Saved Reply' : 'New Saved Reply'}
        btns={this.footerBtns}
      >
        <div>
          <GeckoFields
            fields={fields}
            values={this.state.values}
            handler={this.changeHandler.bind(this)}
          />
        </div>
      </GeckoModal>
    );
  }

  getUserTeams() {
    const allTeams = this.props.teams.map((team) => {
      return {
        label: team.name,
        value: team.id,
      };
    });
    const isAgent = GeckoPermissions.memberOf('agent');

    if (isAgent) {
      const userTeamIds = this.props.myTeamIds;

      const filteredTeams = allTeams.filter((team) =>
        userTeamIds.includes(team.value)
      );
      return filteredTeams;
    }
    return allTeams;
  }
}

const mapStateToProps = (state) => {
  return {
    loggedInUser: state.appState.loggedInUser,
    myTeamIds: state.appState.myTeamIds,
    teams: state.teams,
  };
};
export default connect(mapStateToProps)(EditModal);
